import React from 'react';
import styles from './SearchInput.module.css';
import { SearchInputComponent } from './types';

export const SearchInput: SearchInputComponent = ({ placeholder }) => {
    return (
        <div className={styles.input}>
            <input
                className={styles.text}
                placeholder={placeholder}
                type="search"
            />
        </div>
    );
};
